import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { GetTemplatesQueryParams, Template } from '../models/templates';
import { CommonApiState } from './common';

export const TemplateFetch = createAction('[Template] Fetch', props<GetTemplatesQueryParams>());
export const TemplateFetched = createAction('[Template] Fetched', props<{ templates: Template[] }>());
export const TemplateError = createAction('[Template] Error');

export const initialState: CommonApiState<Template[]> = {
  data: [],
  currentPedingApis: 0,
  isError: false
};

export const templateFeature = createFeature({
  name: 'template',
  reducer: createReducer(
    initialState,
    on(TemplateFetch, state => ({
      ...state,
      currentPedingApis: state.currentPedingApis + 1
    })),
    on(TemplateFetched, (state, result) => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: false,
        data: result.templates
      };
    }),
    on(TemplateError, state => {
      return {
        ...state,
        currentPedingApis: 0,
        isError: true
      };
    })
  ),
  extraSelectors: ({ selectTemplateState }) => {
    const templatesIsLoading = createSelector(
      selectTemplateState,
      templateState => templateState.currentPedingApis > 0
    );

    //Don't let 2 or more action start another request
    const templateHasPendingRequest = createSelector(
      selectTemplateState,
      templateState => templateState.currentPedingApis >= 2
    );

    return { templatesIsLoading, templateHasPendingRequest };
  }
});
